// extracted by mini-css-extract-plugin
module.exports = {"wave2DetailI":"I_wave2DetailI__yBF3c"};